import React, { useEffect, useRef, useState } from "react";
import { Box, Chip } from "@mui/material";

const logos = [
  {
    id: 1,
    img: "07:00 AM",
  },
  {
    id: 2,
    img: "08:00 AM",
  },
  {
    id: 3,
    img: "09:00 AM",
  },
  {
    id: 4,
    img: "10:00 AM",
  },
  {
    id: 5,
    img: "11:00 AM",
  },

  {
    id: 6,
    img: "12:00 PM",
  },
  {
    id: 7,
    img: "01:00 PM",
  },
  {
    id: 8,
    img: "02:00 PM",
  },
  {
    id: 9,
    img: "03:00 PM",
  },
  {
    id: 10,
    img: "04:00 PM",
  },

  {
    id: 11,
    img: "05:00 PM",
  },
  {
    id: 12,
    img: "06:00 PM",
  },
  {
    id: 13,
    img: "07:00 PM",
  },
  {
    id: 14,
    img: "08:00 PM",
  },
  {
    id: 15,
    img: "09:00 PM",
  },
];

const MobileFirstSection = ({ selectedIndex, onIndexChange }) => {
  const scrollContainerRef = useRef(null);
  const chipRefs = useRef([]);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  // Scroll the selected chip into view whenever selectedIndex changes
  useEffect(() => {
    if (chipRefs.current[selectedIndex]) {
      chipRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center", // Center the chip horizontally
      });
    }
  }, [selectedIndex]);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
    setScrollLeft(scrollContainerRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollContainerRef.current.offsetLeft;
    const walk = (x - startX) * 1; // Adjust scroll speed here
    scrollContainerRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleChipClick = (index) => {
    onIndexChange(index); // Notify parent of the selected index
  };

  return (
    <Box
      ref={scrollContainerRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      sx={{
        display: "flex",
         
        // border: "1px solid red",
        overflowX: "auto", // Enable horizontal scrolling
        whiteSpace: "nowrap", // Prevent line breaks
        width: "100%", // Restrict to parent's width
        // padding: "16px",
        cursor: isDragging ? "grabbing" : "grab", // Change cursor during dragging
        "&::-webkit-scrollbar": {
          display: "none", // Hide scrollbar for WebKit browsers
        },
      }}
    >
      {logos.map((logo, index) => (
        <Chip
          key={index}
          ref={(el) => (chipRefs.current[index] = el)}
          label={logo.img}
          variant={selectedIndex === index ? "filled" : "outlined"} // Highlight selected chip
          onClick={() => handleChipClick(index)} // Handle chip click
          sx={{
            borderRadius: "8px",
            marginRight: "16px",
            whiteSpace: "nowrap",
            cursor: "pointer",
            backgroundColor: selectedIndex === index ? "#1E3A8A" : "white",
            color: selectedIndex === index ? "white" : "black",
          }}
        />
      ))}
    </Box>
  );
};

export default MobileFirstSection;
